import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import eventsActionCreators from '_store/_actions/events';

function WhatsAppConfigModal({
  show,
  onHide,
  eventId,
  config,
  onSuccess,
  onCreateWhatsAppConfig,
  onUpdateWhatsAppConfig,
}) {
  const [name, setName] = useState('');
  const [template, setTemplate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (config) {
      setName(config.name || '');
      setTemplate(config.template || '');
    } else {
      setName('');
      setTemplate('');
    }
  }, [config, show]);

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const configData = {
        name,
        template,
      };

      if (config) {
        await onUpdateWhatsAppConfig(eventId, config._id, configData);
        toastr.success('Success', 'WhatsApp notification template updated');
      } else {
        await onCreateWhatsAppConfig(eventId, configData);
        toastr.success('Success', 'WhatsApp notification template created');
      }

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      toastr.error('Error', error.message || 'Failed to save WhatsApp template');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {config ? 'Edit WhatsApp Template' : 'Create WhatsApp Template'}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Template Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. Welcome Message"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              A descriptive name for this template
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Message Template</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Welcome {name} to our event! We're looking forward to seeing you on {event_date}."
              value={template}
              onChange={e => setTemplate(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              Use {'{placeholder}'} for dynamic content. Available placeholders:{' '}
              {'{name}'}, {'{email}'}, {'{phone}'}, {'{event_name}'}, {'{event_date}'},{' '}
              {'{event_location}'}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : config ? 'Update Template' : 'Create Template'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

WhatsAppConfigModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  eventId: PropTypes.string.isRequired,
  config: PropTypes.object,
  onSuccess: PropTypes.func,
  onCreateWhatsAppConfig: PropTypes.func.isRequired,
  onUpdateWhatsAppConfig: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  onCreateWhatsAppConfig: eventsActionCreators.createWhatsAppConfig,
  onUpdateWhatsAppConfig: eventsActionCreators.updateWhatsAppConfig,
};

export default connect(null, mapDispatchToProps)(WhatsAppConfigModal);
